import React from "react"
import { createRoot } from "react-dom/client"
import { Contest } from "../components/contest/Contest"
import { AppContextProvider } from "../hooks/appContext"
import { FlaggedI18nProvider } from "../i18n"

const root = createRoot(document.getElementById("root")!)
root.render(
    <React.StrictMode>
        <AppContextProvider context={window as any}>
            <FlaggedI18nProvider>
                <Contest />
            </FlaggedI18nProvider>
        </AppContextProvider>
    </React.StrictMode>,
)
